import React, { useState, lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import './Comments.css';
import back from "../../images/icons/left-backarrow.svg";

const Messages = lazy(() => import("./Messages"));
const CommentsButton = lazy(() => import("./CommentsButton"));

const CommnetContatiner = ({ from, id, addUsers, permissions }) => {
  const [open, setOpen] = useState(false);

  const toggleComments = () => {
    setOpen(!open);
  };

  const panel = ReactDOM.createPortal(
    <div className={`comments-panel${open ? " comments-panel-open" : ""}`}>
      <div className="comments-header">
        <button className="comments-back-button" onClick={toggleComments}>
          <img src={back} alt="Back Arrow" />
        </button>
        <span>Comments</span>
      </div>
      <Suspense fallback={<div></div>}>
        {open && <Messages from={from} id={id} addUsers={addUsers} permissions={permissions} />}
      </Suspense>
    </div>,
    document.body
  );

  return (
    <div className="comments-wrapper">
      {!open && <Suspense fallback={<div></div>}><CommentsButton toggle={toggleComments} /></Suspense>}
      {panel}
    </div>
  );
};

export default CommnetContatiner;
